export const RELATED_VALUES_DROPDOWN_MAX_ITEM_COUNT = 10;
